<template>
  <b-button
    @click="onClick"
    class="btn d-block float-left btn-chung ml-1 mr-1"
    :disabled="disabled"
    :class="color || getClass()"
  >
    <font-awesome-icon
      v-if="getIcon() == 'save'"
      :icon="getIcon()"
    ></font-awesome-icon>
    <b-icon
      v-if="icon == 'none' || getIcon() == 'save' ? false : getIcon()"
      :icon="icon || getIcon()"
    />
    {{ button }}
  </b-button>
</template>

<script>
export default {
  name: "BaseButton",
  components: {},
  props: {
    button: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
    getClass() {
      switch (this.button) {
        case "Tìm kiếm":
          return "btn-primary btn-blue";
        case "Thêm mới đơn vị":
        case "Thêm mới cán bộ":
        case "Thêm vai trò":
        case "Thêm tỉnh thành":
        case "Thêm nhóm người dùng":
        case "Tạo mới":
        case "Sửa":
        case "Tạo":
        case "Lưu":
        case "Thêm mới":
          return "btn-success btn-green";
        case "Import":
          return "btn-primary btn-blue";
        case "Bỏ qua":
          return "btn-warning btn-yellow";
        case "Cập nhật":
        case "Xác nhận":
        case "Đồng ý":
          return "btn-success btn-green";
        case "Đóng":
        case "Hủy":
        case "Xóa quyền đã chọn":
        case "Xóa vai trò đã chọn":
        case "Xóa nhóm người dùng đã chọn":
        case "Xóa":
          return "btn-danger btn-red";
        case "Tải file Template":
          return "btn-excel";
      }
      return null;
    },
    getIcon() {
      switch (this.button) {
        case "Tìm kiếm":
          return "search";
        case "Thêm mới đơn vị":
        case "Thêm mới cán bộ":
        case "Tạo mới":
        case "Thêm vai trò":
        case "Thêm tỉnh thành":
        case "Thêm nhóm người dùng":
        case "Thêm mới quyền":
        case "Thêm người dùng":
        case "Tạo":
        case "Thêm mới":
          return "plus-circle-fill";
        case "Import":
          return "box-arrow-in-down-left";
        case "Đóng":
        case "Bỏ qua":
          return "x-circle-fill";
        case "Đồng ý":
          //case "Xác nhận":
          return "check-circle-fill";
        case "Xóa vai trò đã chọn":
        case "Xóa nhóm người dùng đã chọn":
        case "Xóa quyền đã chọn":
        case "Xóa":
          return "trash-fill";
        case "Làm mới":
          return "arrow-clockwise";
        case "Export":
          return "box-arrow-up-right";
        case "Export thông tin in thẻ":
          return "box-arrow-up-right";
        case "Hủy":
          return "arrow-repeat";
        case "Sửa":
        case "Cập nhật":
          return "pencil-square";
        case "Tải file Template":
          return "download";
        case "Lưu":
          return "save";
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-chung {
  border: none;
  height: 36px;
  border-radius: 3px;
  text-transform: inherit;
  background-color: #5a8dee;
  color: white;
}

.btn-success {
  background-color: #28c76f !important;
}
.btn-primary {
  background-color: #5a8dee !important;
}
.btn-warning {
  background-color: #f6d00b !important;
}
.btn-danger {
  background-color: #ea5455 !important;
}
.btn-chung.disabled {
  background-color: gray !important;
}
.btn-excel {
  background-color: #2cb566 !important;
}
</style>
